module.exports = __webpack_public_path__ + "static/img/close.3f6f7377.svg";